import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import { TodayProgressMessage, TodayProgressTitle } from '../../../Constant';
//import { todayProgressData } from '../../../Data/OnlineCourse/ChartData';

const TodayProgress = (progressData) => {

  //const [processedSoFar, setApplicationProgress] = useState(15);

  //progressData.todayProgressData.series[1]=progressData.percentCompleted;
  //progressData.todayProgressData.options.plotOptions.radialBar.dataLabels.total.formatter=()=>{return progressData.processedSoFar+"%";};
  const [todayProgressData, setTodayProgressData]=useState(progressData.todayProgressData);
  const [nextProgressStep,setNextProgressStep] = useState(progressData.nextProgressStep);
  var storageProgress=localStorage.getItem("percentCompleted");
        
  function diraUpdateProgress(){//alert(processedSoFar+"-uu-"+param);

    if(localStorage.getItem("percentCompleted")!=null) return localStorage.getItem("percentCompleted")+"%";
    else return progressData.percentCompleted+"%";

  }

  useEffect(() => {

    //alert(progressData.percentCompleted); 
    //alert(progressData.processedSoFar);
    //progressData.todayProgressData.options.plotOptions.radialBar.dataLabels.total.formatter.(){}=()=>{return progressData.processedSoFar+"%";};
    //progressData.todayProgressData.series[1]=progressData.percentCompleted;

    var thisProgressData = {
      series: [100, progressData.percentCompleted],
      options: {
        chart: {
          width: 240,
          height: 360,
          type: "radialBar",
          offsetX: -28,
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                offsetY: 20,
                color: "var(--chart-text-color)",
                fontFamily: "Rubik, sans-serif",
                fontWeight: 500,
              },
              value: {
                fontSize: "22px",
                offsetY: -16,
                fontFamily: "Rubik, sans-serif",
                fontWeight: 500,
                color: "var(--chart-text-color)",
              },
              total: {
                show: true,
                label: "Processed!",
                fontSize: "12px",
                color: "var(--chart-text-color)",
                formatter: diraUpdateProgress,
              },
            },
            hollow: {
              margin: 5,
              size: "70%",
              image: null,
              imageWidth: 115,
              imageHeight: 115,
              imageClipped: false,
            },
            track: {
              background: "transparent",
            },
          },
        },
        colors: ["var(--theme-default)", "#FFA941"],
        labels: ["Submitted by Employee", "Review Progress"],
        stroke: {
          lineCap: "round",
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          offsetY: -15,
          fontSize: "14px",
          fontFamily: "Rubik, sans-serif",
          fontWeight: 500,
          labels: {
            colors: "var(--chart-text-color)",
          },
          markers: {
            width: 6,
            height: 6,
          },
        },
        responsive: [
          {
            breakpoint: 1830,
            options: {
              chart: {
                offsetX: -40,
              },
            },
          },
          {
            breakpoint: 1750,
            options: {
              chart: {
                offsetX: -50,
              },
            },
          },
          {
            breakpoint: 1661,
            options: {
              chart: {
                offsetX: -10,
              },
            },
          },
          {
            breakpoint: 1530,
            options: {
              chart: {
                offsetX: -25,
              },
            },
          },
          {
            breakpoint: 1400,
            options: {
              chart: {
                offsetX: 10,
              },
            },
          },
          {
            breakpoint: 1300,
            options: {
              chart: {
                offsetX: -10,
              },
            },
          },
          {
            breakpoint: 1200,
            options: {
              chart: {
                width: 255,
              },
            },
          },
          {
            breakpoint: 992,
            options: {
              chart: {
                width: 245,
              },
            },
          },
          {
            breakpoint: 600,
            options: {
              chart: {
                width: 225,
              },
            },
          },
        ],
      },
    };
    //thisProgressData.options.plotOptions.radialBar.dataLabels.total.formatter(progressData.percentCompleted);
    thisProgressData.options.plotOptions.radialBar.dataLabels.total.formatter=diraUpdateProgress;//=>{return processedSoFar+"%";};
              
    setNextProgressStep(progressData.nextProgressStep);
    setTodayProgressData(thisProgressData);
    
  
    }, [progressData.processedSoFar,progressData.percentCompleted,storageProgress]);

  return (
    <Card className='get-card'>
      <CardHeader className='card-no-border'>
        <H5>{"Track Application Progress"}</H5>
        <span className='f-14 f-w-500 f-light' style={{alignItems: "center !important",justifyContent: "center !important"}}>{progressData.nextProgressStep}</span>
      </CardHeader>
      <CardBody className='pt-0'>
        <div className='progress-chart-wrap'>
          <ReactApexChart type='radialBar' width={240} height={360} options={todayProgressData.options} series={todayProgressData.series} />
        </div>
      </CardBody>
    </Card>
  );
};

export default TodayProgress;
